// Keeps the membership button label on one line where possible, trying in order:
// 1. label and icon, 2. label without the icon, 3. smaller label without the icon.
// If none fit, the label wraps with the icon (the default, no-JS layout).
if (!customElements.get('membership-button')) {
  customElements.define(
    'membership-button',
    class MembershipButton extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('.membership-button');
        this.label = this.querySelector('.membership-button__label');
        this.icon = this.querySelector('.membership-button__icon-slot');
        if (!this.link || !this.label) return;

        this.fit = this.fit.bind(this);
        this.resizeObserver = new ResizeObserver(this.fit);
        this.resizeObserver.observe(this);
        if (document.fonts) document.fonts.ready.then(this.fit);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      fit() {
        const link = this.link;
        link.classList.remove(
          'membership-button--single-line',
          'membership-button--no-icon',
          'membership-button--compact'
        );

        const styles = getComputedStyle(link);
        const available = link.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
        const iconWidth = this.icon ? this.icon.offsetWidth + parseFloat(styles.columnGap || 0) : 0;
        const labelWidth = this.measureLabel();

        if (labelWidth + iconWidth <= available) {
          link.classList.add('membership-button--single-line');
          return;
        }
        if (labelWidth <= available) {
          link.classList.add('membership-button--single-line', 'membership-button--no-icon');
          return;
        }

        link.classList.add('membership-button--compact');
        if (this.measureLabel() <= available) {
          link.classList.add('membership-button--single-line', 'membership-button--no-icon');
        } else {
          link.classList.remove('membership-button--compact');
        }
      }

      measureLabel() {
        this.link.classList.add('membership-button--measuring');
        const width = this.label.scrollWidth;
        this.link.classList.remove('membership-button--measuring');
        return width;
      }
    }
  );
}
